import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatTreeModule } from '@angular/material/tree';
import { NewDiseaseComponent } from './NewDisease/NewDisease.component';
import { EMRComponent } from './EMR.component';
import { ProcedureComponent } from './Procedure/Procedure.component';
import { CounselorComponent } from './Counselor/Counselor.component';
import { NewSurgeryComponent } from './NewSurgery/NewSurgery.component';
import { Diabetic_SurveyComponent } from './Diabetic_Survey/Diabetic_Survey.component';
import { ExaminationHelpComponent } from './ExaminationHelp/ExaminationHelp.component';
import { TemplateFindingsComponent } from './TemplateFindings/TemplateFindings.component';
import { Template_helpComponent } from './template_help/template_help.component';
import { DiagnosisComponent } from './Diagnosis/Diagnosis.component';
import { Image_workupComponent } from './Image_workup/Image_workup.component';
import { Present_ComplaintsComponent } from './PrimaryExamination/Present_Complaints/Present_Complaints.component';
import { Auto_Ref_DetailsComponent } from './PrimaryExamination/Auto_Ref_Details/Auto_Ref_Details.component';
import { IOPComponent } from './PrimaryExamination/IOP/IOP.component';
import { OldglassComponent } from './PrimaryExamination/oldglass/oldglass.component';
import { VisionComponent } from './PrimaryExamination/Vision/Vision.component';
import { KeratometerComponent } from './PrimaryExamination/Keratometer/Keratometer.component';
import { Ud_and_d_refrationComponent } from './PrimaryExamination/ud_and_d_refration/ud_and_d_refration.component';
import { Additional_visionComponent } from './PrimaryExamination/additional_vision/additional_vision.component';
import { Glass_prescriptionComponent } from './PrimaryExamination/glass_prescription/glass_prescription.component';
import { Opd_testComponent } from './PrimaryExamination/Opd_test/Opd_test.component';
import { Opto_examinationComponent } from './PrimaryExamination/opto_examination/opto_examination.component';
import { Other_info_PEComponent } from './PrimaryExamination/other_info_PE/other_info_PE.component';
import { EyecheckComponent } from './eyecheck/eyecheck.component';
import { Emr_delete_confirmation_boxComponent } from './emr_delete_confirmation_box/emr_delete_confirmation_box.component';
import { OldcaseComponent } from './oldcase/oldcase.component';
import { OpdSettingComponent } from './opd-setting/opd-setting.component';
import { ScrollSpyDirectiveDirective } from './scroll-spy-directive.directive';
import { SharedModule } from 'app/shared/shared.module';
import { DoctorDiagnosisComponent } from './Doctor/doctor-diagnosis/doctor-diagnosis.component';
import { DoctorOtherInfoComponent } from './Doctor/doctor-other-info/doctor-other-info.component';
import { DoctorReviewComponent } from './Doctor/doctor-review/doctor-review.component';
import { FindingExaminationComponent } from './Doctor/finding-examination/finding-examination.component';
import { InvestigationComponent } from './Doctor/investigation/investigation.component';
import { MedicineComponent } from './Doctor/medicine/medicine.component';
import { SurgeryComponent } from './Doctor/surgery/surgery.component';
import { SocialHistoryComponent } from './History/social-history/social-history.component';
import { HistoryOtherInfoComponent } from './History/history-other-info/history-other-info.component';
import { DrugAllergyComponent } from './History/drug-allergy/drug-allergy.component';
import { FamilyHistoryComponent } from './History/family-history/family-history.component';
import { SurgicalHistoryComponent } from './History/surgical-history/surgical-history.component';
import { PastHistoryComponent } from './History/past-history/past-history.component';
import { MedicineTemplateComponent } from './template_help/medicine-template/medicine-template.component';
import { InvestigationServicesComponent } from './Doctor/investigation-services/investigation-services.component';
import { ProcedureDownloadComponent } from './Procedure/procedure-download/procedure-download.component';
import { FileTransferComponent } from './Procedure/file-transfer/file-transfer.component';
import { BranchNameComponent } from './Procedure/branch-name/branch-name.component';
import { PrescriptionSettingComponent } from './prescription-setting/prescription-setting.component';
import { AddNewSurgeryComponent } from './NewSurgery/add-new-surgery/add-new-surgery.component';
import { SearchNewSurgeryComponent } from './NewSurgery/add-new-surgery/search-new-surgery/search-new-surgery.component';
import { HelpListPopupComponent } from './Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { ShowExaminationComponent } from './Counselor/show-examination/show-examination.component';
import { PackageSelectionComponent } from './Counselor/package-selection/package-selection.component';
import { DynamicHelpListComponent } from './Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { PatientOverviewComponent } from './patient-overview/patient-overview.component';
import { ChartsModule } from 'ng2-charts';
import { ToastUiImageEditorModule } from 'ngx-tui-image-editor';
import { ImageTemplateComponent } from './Image_workup/image-template/image-template.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import {dynamicPipe} from './dynamic-filter';
import { HelpListPipe } from './helplist-filter';
import { AdvisedInvestigationsComponent } from './PrimaryExamination/advised-investigations/advised-investigations.component';
import { EmrRoutingModule } from './emr-routing.module';
import { PresentFilterPipe } from './PrimaryExamination/present-filter.pipe';
import { DoctorOtherPipe } from './Doctor/doctor-other-info/doctor-other.pipe';
import { TemplateSearchPipe } from './TemplateFindings/template-filter';
import { CurrentMedicationComponent } from './PrimaryExamination/current-medication/current-medication.component';
import { CommanSurgeryPopupComponent } from './NewSurgery/comman-surgery-popup/comman-surgery-popup.component';
import { OtherSurgeryPopupComponent } from './other-surgery-popup/other-surgery-popup.component';
import { IOLComponent } from './Counselor/iol/iol.component';
import { InhouseSurgeriesComponent } from './Doctor/inhouse-surgeries/inhouse-surgeries.component';
import { LinebreaksPipe } from './linebreak.pipe';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCardModule} from '@angular/material/card';
import { AIPrescriptionComponent } from './Doctor/aiprescription/aiprescription.component';

// RECOMMENDED
import { PopoverModule } from 'ngx-bootstrap/popover';
@NgModule({
  imports: [
    // SignaturePadModule,
    EmrRoutingModule,  
    MatBottomSheetModule,
    MatExpansionModule,
    MatGridListModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSliderModule,
    MatTreeModule,
    SharedModule,
    ChartsModule,
    ToastUiImageEditorModule,
    CarouselModule.forRoot(),
    CommonModule,
    MatCardModule, MatDatepickerModule, PopoverModule.forRoot()
  ],
  declarations: [
    Other_info_PEComponent,
    Opto_examinationComponent,
    Opd_testComponent,
    Glass_prescriptionComponent,
    Additional_visionComponent,
    Ud_and_d_refrationComponent,
    KeratometerComponent,
    VisionComponent,
    OldglassComponent,
    IOPComponent,
    Auto_Ref_DetailsComponent,
    Present_ComplaintsComponent,
    NewDiseaseComponent,
    NewSurgeryComponent,
    Diabetic_SurveyComponent,
    EMRComponent,
    ProcedureComponent,
    CounselorComponent,
    ExaminationHelpComponent,
    TemplateFindingsComponent,
    Template_helpComponent,
    DiagnosisComponent,
    Image_workupComponent,
    EyecheckComponent,
    Emr_delete_confirmation_boxComponent,
    OldcaseComponent,
    OpdSettingComponent,
    ScrollSpyDirectiveDirective,
    FindingExaminationComponent,
    InvestigationComponent,
    MedicineComponent,
    SurgeryComponent,
    DoctorReviewComponent,
    DoctorOtherInfoComponent,
    DoctorDiagnosisComponent,
    SocialHistoryComponent,
    HistoryOtherInfoComponent,
    DrugAllergyComponent,
    FamilyHistoryComponent,
    SurgicalHistoryComponent,
    PastHistoryComponent,
    MedicineTemplateComponent,
    InvestigationServicesComponent,
    ProcedureDownloadComponent,
    FileTransferComponent,
    BranchNameComponent,
    PrescriptionSettingComponent,
    AddNewSurgeryComponent,
    SearchNewSurgeryComponent,
    HelpListPopupComponent,
    ShowExaminationComponent,
    PackageSelectionComponent,
    DynamicHelpListComponent,
    PatientOverviewComponent,
    ImageTemplateComponent,
    dynamicPipe,
    TemplateSearchPipe,
    HelpListPipe,
    AdvisedInvestigationsComponent,
    PresentFilterPipe,
    DoctorOtherPipe,
    CurrentMedicationComponent,
    CommanSurgeryPopupComponent,
    OtherSurgeryPopupComponent,
    IOLComponent,
    InhouseSurgeriesComponent,
    LinebreaksPipe,
    AIPrescriptionComponent
    
  ],
  exports:[
    CounselorComponent
  ]
})
export class EmrModule { }